import Core               from '@/core/Core';
import BaseEntity         from '@/core/misc/BaseEntity';
import Title_ru_RU_Class  from '@/core/misc/decorators/Title_ru_RU_Class';
import Title_ru_RU        from '@/core/misc/decorators/Title_ru_RU';
import TYPES              from '@/core/services/Changelogs/types';
import DateRange          from '@/core/types/DateRange';
import DateSimple         from '@/core/types/DateSimple';
import Density            from '@/core/types/Density';
import Price              from '@/core/types/Price';
import Volume             from '@/core/types/Volume';
import Weight             from '@/core/types/Weight';

/**
 * Строка прайса перевозчика как есть: вес, объём и плотность заполнены тем, что есть в прайсе,
 * стоимость — полная стоимость перевозки. Сетка — строки маршрута с одной датой начала действия
 */
@Title_ru_RU_Class('Тариф маршрута')
class TransportRouteTariff extends BaseEntity {

  @Title_ru_RU('Вес', TYPES.NUMBER)
  public weight: Weight | null;

  @Title_ru_RU('Объём', TYPES.NUMBER)
  public volume: Volume | null;

  @Title_ru_RU('Плотность', TYPES.NUMBER)
  public density: Density | null;

  @Title_ru_RU('Стоимость перевозки', TYPES.PRICE)
  public cost: Price;

  @Title_ru_RU('Период действия', TYPES.DATE_RANGE)
  public validityPeriod: DateRange;

  static fromServer(data: any, result = new TransportRouteTariff()): TransportRouteTariff {
    super.fromServer(data, result);

    result.weight         = Core.utils.hydrate(data.weight, Weight.fromServer);
    result.volume         = Core.utils.hydrate(data.volume, Volume.fromServer);
    result.density        = Core.utils.hydrate(data.density, Density.fromServer);
    result.cost           = Core.utils.hydrate(data.cost, Price.fromServer)!;
    result.validityPeriod = Core.utils.hydrate(data.validityPeriod, DateRange.fromServer)!;

    return result;
  }

  /** Пустая строка сетки, действующей с указанной даты */
  static fromStartDate(start: DateSimple): TransportRouteTariff {
    const result = new TransportRouteTariff();

    result.weight         = Weight.fromEmpty();
    result.volume         = Volume.fromEmpty();
    result.density        = Density.fromEmpty();
    result.cost           = Price.fromEmpty();
    result.validityPeriod = new DateRange(start, null);

    return result;
  }

  /** Строка обновлённых тарифов с порогами прежней строки и пустой стоимостью: прайс перевозчика обычно меняется ценами,
   *  а пустая стоимость не даст тихо унести в расчёт старую цену */
  static fromTariff(tariff: TransportRouteTariff, start: DateSimple): TransportRouteTariff {
    const result = this.fromStartDate(start);

    result.weight  = tariff.weight;
    result.volume  = tariff.volume;
    result.density = tariff.density;

    return result;
  }

  get hasWeight(): boolean {
    return this.weight !== null && this.weight.isEmpty() === false;
  }

  get hasVolume(): boolean {
    return this.volume !== null && this.volume.isEmpty() === false;
  }

  validate(): string[] {
    const errors: string[] = [];

    if (this.hasWeight === false && this.hasVolume === false) {
      errors.push('В строке тарифа укажите вес или объём');
    }

    if (this.cost === null || this.cost.isEmpty() === true) {
      errors.push('В строке тарифа укажите стоимость перевозки');
    }

    return errors;
  }
}

export default TransportRouteTariff;
